import { Component, OnInit } from '@angular/core';
import { ITaskTypeOnHold } from '../../interfaces/task-type-on-hold';
import { TaskTypeOnHoldService } from '../../services';

@Component({
  selector: 'task-type-on-hold',
  templateUrl: 'task-type-on-hold.component.html',
})
export class TaskTypeOnHoldComponent implements OnInit {
  isLoading: boolean;
  items: ITaskTypeOnHold[];

  constructor(private service: TaskTypeOnHoldService) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.service.getAll().then((res) => {
      this.items = res;
      this.isLoading = false;
    });
  }

  save() {
    this.isLoading = true;
    this.service.saveItems(this.items).then(() => {
      this.isLoading = false;
    });
  }
}
